import { createSlice } from "@reduxjs/toolkit";

const ONE_MINUTE = 60000;

export const routerHistorySlice = createSlice({
  name: "routerHistory",
  initialState: {
    history: [],
    latestPathRender: {},
    isFirstRendering: null,
    location: null,
    action: null,
    time: null,
  },
  reducers: {
    addToHistory: (state, action) => {
      const currentTimestamp = Date.now();
      const locationPath = action.payload?.location?.pathname;
      const locationWasRendered = Object.keys(state.latestPathRender).includes(
        locationPath
      );
      const lastTimestamp = state.latestPathRender[locationPath];

      state.history.push({ ...action.payload, currentTimestamp });
      state.isFirstRendering = action.payload.isFirstRendering;
      state.location = action.payload.location;
      state.action = action.payload.action;
      state.time = currentTimestamp;

      if (!locationWasRendered) {
        state.latestPathRender[locationPath] = null;
      }

      if (currentTimestamp - lastTimestamp > ONE_MINUTE) {
        state.latestPathRender[locationPath] = currentTimestamp;
      }
    },
  },
});

export const { addToHistory } = routerHistorySlice.actions;
export const { actions } = routerHistorySlice;

export const shouldFetch = ({ routerHistory }) => {
  const isServer = !(
    typeof window !== "undefined" &&
    window.document &&
    window.document.createElement
  );

  // if we are on the server, we should always fetch
  if (isServer) return true;
  // if we are on the client and this is the first rendering, we should fetch
  if (routerHistory.isFirstRendering === true) return true;
  // if we are on the client and the latest render was more than 1 minutes ago, we should fetch

  const currentTimestamp = Date.now();
  const lastTimestamp =
    routerHistory.latestPathRender[window.location.pathname];

  if (lastTimestamp === null) return true;

  return currentTimestamp - lastTimestamp > ONE_MINUTE;
};

export default routerHistorySlice.reducer;
